import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';
import type { Role } from '@src/domain/rbac/entities/role.entity';

/**
 * List All Roles Use Case
 * Retrieves all roles in the system
 */
export class ListAllRolesUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(): Promise<Role[]> {
        return await this.roleRepository.listAll();
    }
}
